import BliButton from '@blibli/blue.button/dist/button/blue/Button'
import BliEmptyState from '@blibli/blue.empty-state/dist/empty-state/blue/EmptyState'

import UnableToLoadPageImage from '@/assets/images/illustration/session-timed-out.svg'
export default {
  name: 'ErrorState',
  components: {
    BliEmptyState,
    BliButton
  },
  data () {
    return {
      UnableToLoadPageImage
    }
  },
  methods: {
    reload () {
      window.location.reload()
    }
  }
}
